import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Config from '../../commons/config/Config.js'
import Security from '../../commons/security/Security.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import $ from 'jquery'
import moment from 'moment'
import DataTable from 'datatables.net-bs4'
import 'datatables.net-bs4/css/dataTables.bootstrap4.css'
import 'datatables.net-autofill-bs4'
import 'datatables.net-buttons-bs4'
import 'datatables.net-buttons/js/buttons.colVis.js'
import 'datatables.net-buttons/js/buttons.flash.js'
import 'datatables.net-buttons/js/buttons.html5.js'
import 'datatables.net-buttons/js/buttons.print.js'
import 'datatables.net-colreorder-bs4/css/colReorder.bootstrap4.min.css'
import 'datatables.net-fixedcolumns-bs4/css/fixedColumns.bootstrap4.min.css'
import 'datatables.net-fixedheader-bs4/css/fixedHeader.bootstrap4.min.css'
import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'
import 'datatables.net-responsive-bs4'
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.min.css'
import 'datatables.net-rowreorder-bs4/css/rowReorder.bootstrap4.css'
import 'datatables.net-scroller-bs4/css/scroller.bootstrap4.min.css'
import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
import '../../assets/css/vec-datatables.css'
import LocaleFormat from '../../commons/utils/LocaleFormat.js'
import datatablesConfig from '../../commons/datatables/DatatablesConfig.js'
import { createExcelExportButton } from '../../commons/datatables/DataTablesExcelButton.js'
import jzip from 'xlsx/dist/jszip'
import 'xlsx/dist/xlsx.full.min.js'
import swal from 'sweetalert'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import LimpiarFiltros from '../../assets/images/limpiar-filtros.svg'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import Timezone from '../../commons/timezone/Timezone.js';
import FacturasGridExport from './FacturasGridExport.jsx';
import FacturasTicketsModal from './FacturasTicketsModal.jsx';
import GridFilterPanel, { buildEmptyFilterState, serializeFilterState } from '../../commons/filters/GridFilterPanel.jsx';
import GridSearchResultsBadge from '../../commons/filters/GridSearchResultsBadge.jsx';
import { buildFacturasFilterFields, getFacturasFilterDefaults, armarBusquedaTickets, FACTURAS_FILTROS_STORAGE_KEY } from './facturasFilterFields.js';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

// WE y OE son texto libre cargado al aprobar la factura y DataTables inserta lo que devuelve el render como HTML.
const escapeHtml = (valor) =>
	String(valor == null ? '' : valor)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');

$.DataTable = DataTable;
window.JSZip = jzip;
var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');


pdfMake.vfs = pdfFonts.pdfMake.vfs;

class FacturasGrid extends Component {
	constructor(props) {
		super(props);


		moment.locale('es');

		this.ajaxHandler = new AjaxHandler();

		this.columnsToPrint = [0,1,2,3,4,5,6,7,8,9,10];

		this.configCambiosEstados = ConfigBusiness.get('facturas.cambiosEstados');

		// El método de pago del ticket es opcional por instancia. La columna se gatea
		// solo por el flag; el filtro además necesita listar los métodos, que pide
		// su propio permiso. Se calculan acá porque los usan render() e initGrid().
		this.metodoPagoHabilitado = ConfigBusiness.get('tickets.metodoPago.habilitado') === 'true';
		this.puedeFiltrarMetodoPago = this.metodoPagoHabilitado && Security.hasPermission('METODOS_PAGO_LISTAR');

		this.state = {
			redirectTo: null,
			modalExport: false,
			exportFacturaId: null,
			// VEC-4067: fila de la factura cuyo listado de tickets se muestra en el modal (null = cerrado).
			ticketsModalFactura: null,
			loading: false,
			dropdownActive: false,
			filterResetInputs: false,
			filterQuery: null,
			filtersData: {},
			searchActive: false,
			searchPageRows: 0,
			searchTotalRows: 0
		}

		this.handleFilterChange = this.handleFilterChange.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleSearchClear = this.handleSearchClear.bind(this);
	}

	componentDidMount(nextProps, nextState) {
		if(Security.hasPermission('FACTURAS_LISTAR')) {
	      	this.ajaxHandler.subscribe(this);
			this.initGrid();
	    } else {
		    this.setState({
		        redirectTo: '/error'
	      	});
	    }
	}

	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
		$('div.tooltip[role="tooltip"]').remove();
		if(this.table) this.table.destroy();
	}

	// Campos declarados del panel de filtros. Se calculan una vez porque los usan
	// render() (para el panel) e initGrid()/getDefaultFilterQuery() (para serializar).
	getFilterFields() {
		if (!this.filterFields) {
			this.filterFields = buildFacturasFilterFields({
				mostrarNroPrefacturacion: ConfigBusiness.get('facturas.prefacturacion.habilitado') === 'true',
				mostrarOeWe: ConfigBusiness.get('facturas.sap.habilitado') === 'true',
				mostrarMetodoDePago: this.puedeFiltrarMetodoPago,
				onBuscarTickets: (texto) => this.buscarTickets(texto)
			});
		}
		return this.filterFields;
	}

	// VEC-4067: opciones del selector "Ticket", buscadas en el servidor mientras se tipea (sin texto, los
	// más recientes). Un fallo de red devuelve lista vacía: el desplegable muestra "sin resultados" en vez
	// de romper el panel.
	buscarTickets(texto) {
		const busqueda = texto ? String(texto).trim() : '';
		const query = busqueda ? '?busqueda=' + encodeURIComponent(busqueda) : '';
		return this.ajaxHandler.getJson('/facturas/tickets-select' + query)
			.then((opciones) => (Array.isArray(opciones) ? opciones : []))
			.catch(() => []);
	}

	// Query por defecto: los campos vacíos + los defaults declarados (rango último
	// mes), serializados con las MISMAS reglas que usa el panel al aplicar.
	getDefaultFilterQuery() {
		const fields = this.getFilterFields();
		const estado = Object.assign({}, buildEmptyFilterState(fields), getFacturasFilterDefaults());
		return serializeFilterState(fields, estado);
	}

	// Serializa un estado de filtros crudo (el shape que persiste el panel en
	// localStorage: arrays de {value,label} y fechas en YYYY-MM-DD) al query de
	// valores primitivos que consume handleFilterChange.
	normalizeFilterQuery(query) {
		if (!query) return query;
		return serializeFilterState(this.getFilterFields(), query);
	}

	// La franja verde de "resultados de búsqueda" se muestra solo cuando hay una
	// búsqueda real del usuario, es decir cuando el query difiere del default
	// (rango último mes y el resto vacío). Así la "x" —que vuelve al default—
	// siempre termina ocultando la franja.
	isFilterQueryNonDefault(query) {
		if (!query) return false;
		const def = this.getDefaultFilterQuery();
		const keys = Object.keys(def);
		for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
			const actual = query[k] === undefined || query[k] === null ? '' : String(query[k]);
			const esperado = def[k] === undefined || def[k] === null ? '' : String(def[k]);
			if (actual !== esperado) return true;
		}
		return false;
	}

	// Mapea cada data key del backend al índice de columna real de DataTables.
	// Se calcula dinámicamente porque la columna nroPrefacturacion es condicional
	// (gateada por flag) y desplaza los índices.
	getColumnIndexByData(dataKey) {
		if (!this.table) return -1;
		const cols = this.table.settings()[0].aoColumns;
		for (let i = 0; i < cols.length; i++) {
			if (cols[i].data === dataKey) return i;
		}
		return -1;
	}

	handleFilterChange(filterQuery) {
		if (!this.table) return;

		// Filtros simples: data key del backend.
		const simpleKeys = ['nroPrefacturacion', 'gerenciador', 'tipo', 'puntoDeVenta', 'numero', 'fecha', 'metodoDePago', 'quincena', 'mes', 'anio', 'importe', 'we', 'oe', 'estado', 'tickets'];

		simpleKeys.forEach((key) => {
			const idx = this.getColumnIndexByData(key);
			if (idx >= 0) {
				let val = filterQuery && filterQuery[key] ? String(filterQuery[key]) : '';
				// VEC-4067: los tickets viajan en dos claves del filtro (chips + texto sin elegir).
				if (key === 'tickets') {
					val = armarBusquedaTickets(filterQuery ? filterQuery.tickets : '', filterQuery ? filterQuery.ticketsTexto : '');
				}
				this.table.column(idx).search(val);
			}
		});

		// Rango de fecha de creación: el backend espera "DD-MM-YYYY|DD-MM-YYYY"
		// (desde|hasta) en la columna fechaCreacion. Si ambos vacíos => ''.
		const fechaCreacionIdx = this.getColumnIndexByData('fechaCreacion');
		if (fechaCreacionIdx >= 0) {
			const desde = filterQuery && filterQuery.fechaCreacionDesde ? filterQuery.fechaCreacionDesde : '';
			const hasta = filterQuery && filterQuery.fechaCreacionHasta ? filterQuery.fechaCreacionHasta : '';
			let rangeValue = '';
			if (desde || hasta) {
				const desdeFmt = desde ? moment(desde, 'YYYY-MM-DD').format('DD-MM-YYYY') : '';
				const hastaFmt = hasta ? moment(hasta, 'YYYY-MM-DD').format('DD-MM-YYYY') : '';
				rangeValue = desdeFmt + '|' + hastaFmt;
			}
			this.table.column(fechaCreacionIdx).search(rangeValue);
		}

		this.setState({ searchActive: this.isFilterQueryNonDefault(filterQuery) });

		this.table.draw();
	}

	// LIMPIAR LA BÚSQUEDA — es lo que hace la "x" de la franja de resultados.
	// Devuelve los filtros al default y oculta la franja. NO toca el ordenamiento ni
	// la visibilidad de columnas: eso es del reset total (handleFilterReset).
	handleSearchClear() {
		// Se limpia la entrada persistida; el panel de filtros, al recibir
		// filterResetInputs, vuelve a escribirla con el default (la persistencia es
		// incondicional), así que el estado final guardado es el default.
		localStorage.removeItem(Security.claveDeUsuario(FACTURAS_FILTROS_STORAGE_KEY));
		const defaultQuery = this.normalizeFilterQuery(this.getDefaultFilterQuery());
		this.setState({
			filterResetInputs: true,
			filterQuery: defaultQuery,
			searchActive: false
		});
		this.handleFilterChange(defaultQuery);
	}

	// RESET TOTAL — es lo que hace el botón "Restaurar" del toolbar.
	// Además de limpiar la búsqueda, devuelve el ordenamiento por defecto y vuelve a
	// mostrar todas las columnas que el usuario pudo ocultar con el selector.
	handleFilterReset() {
		if (this.table) {
			// El segundo parámetro en false evita un redibujado por columna; el draw()
			// lo hace handleSearchClear al final. El stateSave persiste la visibilidad.
			this.table.columns().visible(true, false);
			this.table.columns.adjust();

			// El índice de la columna "Número" depende de si está la columna
			// condicional Nro. Prefacturación (VEC-3550). Se ordena ANTES de limpiar la
			// búsqueda para que el draw() de esta sea el único (evita dos requests).
			const numeroIdx = this.getColumnIndexByData('numero');
			this.table.order([ numeroIdx >= 0 ? numeroIdx : 4, 'desc' ]);
		}
		this.setState({ dropdownActive: false });
		this.handleSearchClear();
	}

	handleNew(event) {
		this.setState({
			redirectTo: this.props.match.url + '/add'
		});
	}

	render() {
		// VEC-3413: los filtros ya no viven en el tfoot de la tabla (no hay más inputs por columna
		// inyectados por DataTables); se renderizan en el panel <GridFilterPanel /> y se aplican
		// por data key vía handleFilterChange(). Por eso acá no se necesita el flag de prefacturación.
		return (
			<React.Fragment>
				{this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
				<FacturasGridExport
					open={this.state.modalExport}
					facturaId={this.state.exportFacturaId}
					handleClose={() => this.setState({ modalExport: false })}
				/>
				<FacturasTicketsModal
					open={!!this.state.ticketsModalFactura}
					factura={this.state.ticketsModalFactura}
					handleClose={() => this.setState({ ticketsModalFactura: null })}
				/>
				<div className="row mt-2">
					<div className="col-12">
						<div className="card">
							<div className="card-content collpase show">
								<div className="card-body card-dashboard">
									<div className="container-fluid">
										{/* VEC-3413: tres columnas iguales (botones / franja de resultados /
										    #buttons de DataTables), mismo layout que TicketsGrid y MovilesGrid.
										    Con col-6 + col + col-6 se pasa de 12 y el #buttons se va de línea. */}
										<div className="row dt-icons">
											<div className="col">
												{Security.renderIfHasPermission('FACTURAS_CREAR', (
												<div className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon" onClick={this.handleNew.bind(this)} data-toggle="tooltip" data-placement="right" title={this.props.intl.formatMessage({ id: 'facturasGrid.render.add_button.title_nueva', defaultMessage: 'Nueva' })}>
													<i className="ft-plus"></i>
												</div>
												))}
												<div
													className="btn btn-grey-blue box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
													onClick={() => this.setState({ dropdownActive: !this.state.dropdownActive })}
													data-toggle="tooltip"
													data-placement="right"
													title={this.props.intl.formatMessage({ id: 'facturasGrid.render.button_filtros.title', defaultMessage: 'Filtros' })}
												>
													{this.state.dropdownActive ? <KeyboardArrowUpIcon /> : <ExpandMoreIcon />}
												</div>
											</div>
											{/* Franja de "resultados de búsqueda" con reset. Componente compartido:
											    src/commons/filters/GridSearchResultsBadge.jsx */}
											<div className="col">
												<GridSearchResultsBadge
													visible={this.state.searchActive}
													mostrados={this.state.searchPageRows}
													total={this.state.searchTotalRows}
													onReset={this.handleSearchClear}
												/>
											</div>
											<div className="col" id="buttons"></div>
										</div>
									</div>
									{/* Panel de filtros compartido: src/commons/filters/GridFilterPanel.jsx.
									    Los campos se declaran en ./facturasFilterFields.js */}
									<GridFilterPanel
										open={this.state.dropdownActive}
										fields={this.getFilterFields()}
										options={this.state.filtersData}
										defaults={getFacturasFilterDefaults()}
										storageKey={FACTURAS_FILTROS_STORAGE_KEY}
										loading={this.state.loading}
										resetSignal={this.state.filterResetInputs}
										onResetSignalHandled={() => this.setState({ filterResetInputs: false })}
										onApply={(query) => { this.setState({ filterQuery: query }); this.handleFilterChange(query); }}
									/>
									<div className="table-responsive">
										<table id="dataTable" className="table nowrap server-side table-hover" ref="grid" width="100%">
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}

	initGrid() {
		window.scrollTo(0, 0);
		let component = this;
		var sap = false;
		// VEC-3550: la columna "Nro. Prefacturación" (condicional) se muestra primera, antes de
		// "Fecha de creación". Al anteponerla, todas las columnas siguientes corren +1, por eso el
		// índice del orden por defecto (columna "Número") pasa de 4 a 5 cuando prefacturación está ON.
		const prefacturacionHabilitado = ConfigBusiness.get('facturas.prefacturacion.habilitado') === 'true';
		const ordenPorNumeroIndex = prefacturacionHabilitado ? 5 : 4;
		const metodoPagoHabilitado = this.metodoPagoHabilitado;
		const puedeFiltrarMetodoPago = this.puedeFiltrarMetodoPago;

		Promise.all([
			this.ajaxHandler.getJson('/gerenciadores/select-filtered-by-user'),
			ConfigBusiness.get('facturas.sap.habilitado') === 'true' ? true : false,
			// No existe un endpoint /select de métodos de pago: se reusa el listado del CRUD
			// y se mapea a {value,label} acá, igual que el modal de Modificar Asignación.
			// showDisabled=false porque por defecto el endpoint incluye los deshabilitados.
			puedeFiltrarMetodoPago ? this.ajaxHandler.getJson('/metodos-de-pago?showDisabled=false') : null,
		]).then((data) => {
			sap = data[1];
			const metodosDePago = (data[2] && data[2].metodosDePago) ? data[2].metodosDePago : [];
			let filters = {
				metodoDePago: metodosDePago.map((m) => ({ value: m.id, label: m.name })),
				gerenciador: data[0] ? data[0] : [],
				quincena: [{value: 1, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_fortnight_filter.label_primera', defaultMessage: 'Primera' })}, {value: 2, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_fortnight_filter.label_segunda', defaultMessage: 'Segunda' })}],
				mes: [{value:1, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month_filter.label_enero', defaultMessage: 'Enero' })}, {value:2, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month_filter.label_febrero', defaultMessage: 'Febrero' })}, {value:3, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month_filter.label_marzo', defaultMessage: 'Marzo' })}, {value:4, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month_filter.label_abril', defaultMessage: 'Abril' })}, {value:5, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month_filter.label_mayo', defaultMessage: 'Mayo' })}, {value:6, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month_filter.label_junio', defaultMessage: 'Junio' })}, {value:7, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month_filter.label_julio', defaultMessage: 'Julio' })}, {value:8, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month_filter.label_agosto', defaultMessage: 'Agosto' })}, {value:9, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month_filter.label_septiembre', defaultMessage: 'Septiembre' })}, {value:10, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month_filter.label_octubre', defaultMessage: 'Octubre' })}, {value:11, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month_filter.label_noviembre', defaultMessage: 'Noviembre' })}, {value:12, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month_filter.label_diciembre', defaultMessage: 'Diciembre' })}],
				estado: [
					{
						value: 'PREFACTURADA', label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_satate_filter.label_prefacturadas', defaultMessage: 'Prefacturadas' })
					},
					{
						value: 'PENDIENTE', label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_satate_filter.label_pendientes', defaultMessage: 'Pendientes' })
					},
					{
						value: 'APROBADA', label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_satate_filter.label_aprobadas', defaultMessage: 'Aprobadas' })
					},
					{
						value: 'RECHAZADA', label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_satate_filter.label_rechazadas', defaultMessage: 'Rechazadas' })
					},
					{
						value: 'PAGADA', label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_satate_filter.label_pagadas', defaultMessage: 'Pagadas' })
					}
				].concat(
					component.configCambiosEstados && component.configCambiosEstados.CERRAR && component.configCambiosEstados.CERRAR.habilitado === 'true'
						? [{ value: 'CERRADA', label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_satate_filter.label_cerradas', defaultMessage: 'Cerradas' }) }]
						: []
				)
			}

			component.setState({ filtersData: filters });

			// *** LA CLAVE DEL stateSave VA ACOTADA AL USUARIO (VEC-4018). ***
			// En ese blob viajan juntos el ORDEN, el LARGO DE PÁGINA y las COLUMNAS VISIBLES:
			// con una clave fija, en una terminal compartida el que entra hereda la vista que
			// dejó el anterior. Mismo criterio que los filtros en VEC-3769, y por eso la clave
			// se resuelve igual: `migrarClaveSinUsuario` es TEMPORAL (ver Security.js) y adopta
			// por única vez la entrada sin usuario que dejó la versión anterior.
			// Se resuelve UNA vez, acá: llamarla dentro de los callbacks la ejecutaría en cada
			// draw, y lo único que hace falta es el nombre de la clave.
			const claveEstado = Security.migrarClaveSinUsuario('DataTables_FacturasGrid');

			this.table = $(this.refs.grid).DataTable(
				Object.assign({
					dom: 'r<t><"row mt-2"<"col-4" l><"col-4 text-center" i><"col-4" p>>',
					stateSave: true,
					stateSaveCallback: function(settings, data) {
						localStorage.setItem(claveEstado, JSON.stringify(data));
					},
					stateLoadCallback: function(settings) {
						return JSON.parse(localStorage.getItem(claveEstado));
					},
					processing: true,
					serverSide: true,
					// Sin esto DataTables dispara su ajax al construirse, ANTES de que se apliquen
					// los filtros de abajo: se iba una consulta sin filtrar (con su COUNT sobre toda
					// la tabla) cuyo resultado se descartaba en el acto. Con deferLoading la tabla
					// no carga sola y el draw() de handleFilterChange —que corre siempre, en las
					// tres ramas— queda como la única petición, ya filtrada.
					deferLoading: 0,
					order: [[ ordenPorNumeroIndex, "desc" ]],
					ajax: {
						type: 'GET',
						url: Config.get('apiUrlBase') + '/facturas/grid',
						headers: {
							'Authorization-Token': localStorage.getItem("token")
						},
						dataSrc: function(response) {
							return response.data;
						},
						error: function(xhr, error, thrown) {
							component.ajaxHandler.handleResponseErrorsIsValid(xhr);
						},
						cache: false
					},
					columns: [
					...(prefacturacionHabilitado ? [{
						name: 'nroPrefacturacion',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_nro_prefacturacion', defaultMessage: 'Nro. Prefacturación' }),
						className: 'all w-100-px',
						data: 'nroPrefacturacion',
						render: function(data, type, row) {
							return data ? data : '';
						}
					}] : []),
					{
						name: 'fechaDeCreacion',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_creation_date', defaultMessage: 'Fecha de creación' }),
						className: 'all',
						data: 'fechaCreacion',
						filterType: 'date'
					},{
						name: 'gerenciador',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_fortnight.label_prefacturadas', defaultMessage: 'Gerenciador' }),
						className: 'all w-100-px',
						data: 'gerenciador',
						render: function(data, type, row) {
							if (type === 'filter') {
								return data && data.id ? data.id : '';
							} else {
								return data && data.razonSocial ? data.razonSocial : '';
							}
						},
						filterType: 'select'
					}, {
						name: 'tipo',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_type.label_tipo', defaultMessage: 'Tipo' }),
						className: 'all w-100-px',
						data: 'tipo',
						filterType: 'input'
					}, {
						name: 'puntoDeVenta',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_pointOfSale.label_punto_Venta', defaultMessage: 'Punto de Venta' }),
						className: 'all w-75-px',
						data: 'puntoDeVenta',
						filterType: 'input'
					}, {
						name: 'numero',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_number.label_numero', defaultMessage: 'Número' }),
						className: 'all w-75-px',
						data: 'numero',
						filterType: 'input'
					},
					// VEC-4067: tickets asociados a la factura (directos y vía OT). Con uno solo se muestra su
					// número como link a la vista detallada (pestaña nueva); con varios, un badge que abre un
					// modal con el listado. Los ids vienen del backend como enteros.
					{
						orderable: false,
						name: 'tickets',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_ticket', defaultMessage: 'Ticket' }),
						className: 'all',
						data: 'tickets',
						render: function(data, type, row) {
							const tickets = Array.isArray(data) ? data.map(function(id) { return parseInt(id, 10); }).filter(function(id) { return !isNaN(id); }) : [];
							if (type !== 'display') {
								return tickets.join(', ');
							}
							if (tickets.length === 0) {
								return '';
							}
							if (tickets.length === 1) {
								// Link común, como cualquier otro de la plataforma (sin ícono): abre en una pestaña nueva.
								return '<a href="/tickets/' + tickets[0] + '" target="_blank" rel="noopener noreferrer" title="' +
									component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_ticket.title_abrir_ticket', defaultMessage: 'Se abre en una pestaña nueva' }) + '">' +
									tickets[0] + '</a>';
							}
							// Pill gris del módulo Período de Presupuestos (el estado "Sin asignar" de PresupuestoColorLegenda), sin el
							// bullet (VEC-4067, definición de producto: Marce pidió explícitamente el gris).
							// <button> y no un <a href="javascript:void(0)">: abre un diálogo, no navega, y así los lectores de pantalla lo
							// anuncian como botón (aria-haspopup="dialog"). El ancho y alto en auto anulan el tamaño fijo que el tema les
							// pone a los .action de las grillas.
							return '<button type="button" class="action ver-tickets" aria-haspopup="dialog" style="width:auto;height:auto;margin:0;cursor:pointer;display:inline-block;border:1px solid gray;border-radius:20px;padding:4px 12px;background-color:rgba(128,128,128,0.08);color:gray;font-size:0.9rem;line-height:1.5;white-space:nowrap" title="' +
								component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_ticket.title_ver_tickets', defaultMessage: 'Ver los tickets asociados' }) + '">' +
								component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_ticket.badge_tickets', defaultMessage: 'Tickets' }) + ' ' + tickets.length + '</button>';
						}
					},
					{
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_date.label_fecha', defaultMessage: 'Fecha' }),
						name: 'fecha',
						className: 'all',
						data: 'fecha',
						render: function(data, type, full, meta) {
							return data ? Timezone.getDateForClient(data, 'YYYY-MM-DD HH:mm:ss', 'L') : '';
						},
						filterType: 'input'
					},
					// VEC-3413: la columna Método de pago se muestra solo si la feature está
					// habilitada; el dato se carga a mano desde "Modificar Asignación" del ticket
					// y con el flag apagado la columna sale siempre vacía.
					...(metodoPagoHabilitado ? [{
						orderable: false,
						name: 'metodoDePago',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_payment_method', defaultMessage: 'Método de pago' }),
						className: 'all',
						data: 'metodoDePago',
						render: function(data, type, row) {
							return data ? data : '';
						}
					}] : []),
					{
						name: 'quincena',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_fortnight.label_quincena', defaultMessage: 'Quincena' }),
						className: 'all w-75-px' ,
						data: 'quincena',
						filterType: 'select',
						render: function(data, type, full, meta) {
							if (type === 'filter') {
								return data
							} else {
								if(data === 1) return component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_fortnight.content_primera', defaultMessage: 'Primera' });
								if(data === 2) return component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_fortnight.content_segunda', defaultMessage: 'Segunda' });
							}
						}
					}, {
						name: 'mes',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month.label_mes', defaultMessage: 'Mes' }),
						className: 'all w-75-px',
						data: 'mes',
						render: function(data, type, row) {
							let meses = [{id: 1, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month.content_enero', defaultMessage: 'Enero' })}, {id: 2, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month.content_febrero', defaultMessage: 'Febrero' })}, {id: 3, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month.content_marzo', defaultMessage: 'Marzo' })}, {id: 4, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month.content_abril', defaultMessage: 'Abril' })}, {id: 5, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month.content_mayo', defaultMessage: 'Mayo' })}, {id: 6, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month.content_junio', defaultMessage: 'Junio' })}, {id: 7, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month.content_julio', defaultMessage: 'Julio' })}, {id: 8, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month.content_agosto', defaultMessage: 'Agosto' })}, {id: 9, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month.content_septiembre', defaultMessage: 'Septiembre' })}, {id: 10, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month.content_octubre', defaultMessage: 'Octubre' })}, {id: 11, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month.content_noviembre', defaultMessage: 'Noviembre' })}, {id: 12, label: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_month.content_diciembre', defaultMessage: 'Diciembre' })}];
							return data ? meses.filter(e => e.id === data)[0].label : '';
						},
						filterType: 'select'
					}, {
						name: 'anio',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_year.label_año', defaultMessage: 'Año' }),
						className: 'all w-75-px',
						data: 'anio',
						filterType: 'input'
					}, {
						name: 'importe',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_amount.label_importe', defaultMessage: 'Importe' }),
						className: 'all',
						data: 'importe',
						render: function(data, type, row) {
							return data ? new Intl.NumberFormat(LocaleFormat.getNumberLocale(), { style: 'currency', currency: 'ARS' }).format(data) : '';
						},
						filterType: 'input'
					},
					// VEC-4495: WE y OE de la factura, solo con la configuración de SAP habilitada (la misma que
					// los muestra en el detalle de la factura aprobada).
					...(sap ? [{
						name: 'we',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_we', defaultMessage: 'WE' }),
						className: 'all',
						data: 'we',
						filterType: 'input',
						render: function(data) {
							return escapeHtml(data);
						}
					}, {
						name: 'oe',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_oe', defaultMessage: 'OE' }),
						className: 'all',
						data: 'oe',
						filterType: 'input',
						render: function(data) {
							return escapeHtml(data);
						}
					}] : []),
					{
						name: 'estado',
						title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_state.label_estado', defaultMessage: 'Estado' }),
						className: 'all',
						data: 'estado',
						filterType: 'select'
					}, {
						orderable: false,
						name: 'observacionesCambioEstado',
						title: '',
						data: 'observacionesCambioEstado',
						// no-colvis: columna sin título (icono), se excluye del selector de columnas
						className: 'all no-colvis',
						render: function(data, type, full, meta) {
							return data ? '<div class="text-success dt-info-icon"><i class="ft-message-square" data-togle="tooltip" data-placement="top" title="'+ data + '"></i></div>' : '';
						},
						createdCell: function(td, cellData, rowData, row, col) {
							$(td).find('div > i').tooltip();
						},
						filterType: 'none'
					}, {
						orderable: false,
						data: null,
						// no-colvis: columna de acciones, no debe poder ocultarse desde el selector
						className: "text-left all no-colvis",
						width: '120px',
						render: function(data, type, full, meta) {
							let html =
								(Security.hasPermission('FACTURAS_VISUALIZAR') ? `
								<button class="action view btn btn-sm btn-icon btn-dt-grid text-success" title="`+component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_actions.title_ver', defaultMessage: 'Ver' })+`" data-togle="tooltip" data-placement="top">
									<i class="fa fa-search fa-xs"></i>
								</button>` : '') +
								(data.estado === 'PREFACTURADA' && Security.hasPermission('FACTURAS_MODIFICAR') ? `
								<button class="action edit btn btn-sm btn-icon btn-dt-grid text-success" title="`+component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_actions.title_editar', defaultMessage: 'Editar' })+`" data-togle="tooltip" data-placement="top">
									<i class="fa fa-pencil fa-xs"></i>
								</button>` : '') +
								(data.estado === 'PREFACTURADA' && Security.hasPermission('FACTURAS_ELIMINAR') ? `
								<button class="action delete btn btn-sm btn-icon btn-dt-grid text-danger" title="`+component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_actions.title_eliminar', defaultMessage: 'Eliminar' })+`" data-togle="tooltip" data-placement="top">
									<i class="fa fa-trash fa-xs"></i>
								</button>` : '') +
								(data.estado === 'PENDIENTE' && Security.hasPermission('FACTURAS_APROBAR') ? `
								<button class="action approve btn btn-sm btn-icon btn-dt-grid text-success" title="`+component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_actions.title_aprobar', defaultMessage: 'Aprobar' })+`" data-togle="tooltip" data-placement="top">
									<i class="fa fa-thumbs-up fa-xs"></i>
								</button>` : '') +
								(data.estado === 'PENDIENTE' && Security.hasPermission('FACTURAS_RECHAZAR') ? `
								<button class="action reject btn btn-sm btn-icon btn-dt-grid text-danger" title="`+component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_actions.title_rechazar', defaultMessage: 'Rechazar' })+`" data-togle="tooltip" data-placement="top">
									<i class="fa fa-thumbs-down fa-xs"></i>
								</button>` : '') +
								(data.estado === 'APROBADA' && Security.hasPermission('FACTURAS_PAGAR') ? `
								<button class="action declarePayment btn btn-sm btn-icon btn-dt-grid text-success" title="`+component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_actions.title_declarar_pago', defaultMessage: 'Declarar Pago' })+`" data-togle="tooltip" data-placement="top">
									<i class="fa fa-dollar fa-xs"></i>
								</button>` : '') +
								(
									data.estado === 'PAGADA'
									&& data.comprobantePago
									&& Security.hasPermission('FACTURAS_PAGAR') ? `
								<button class="action downloadReceipt btn btn-sm btn-icon btn-dt-grid text-success" title="`+component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_actions.title_comprobante_pago', defaultMessage: 'Comprobante de Pago' })+`" data-togle="tooltip" data-placement="top">
									<i class="fas fa-money-check fa-xs"></i>
								</button>` : '') +
								(
									data.estado === 'PAGADA'
									&& component.configCambiosEstados
									&& component.configCambiosEstados.CERRAR
									&& component.configCambiosEstados.CERRAR.habilitado === 'true'
									&& Security.hasPermission('FACTURAS_CERRAR') ? `
								<button class="action close-factura btn btn-sm btn-icon btn-dt-grid text-success" title="`+component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_actions.title_cerrar', defaultMessage: 'Cerrar factura' })+`" data-togle="tooltip" data-placement="top">
									<i class="ft-lock" style="-webkit-text-stroke: 0.5px;"></i>
								</button>` : '') +
							(Security.hasPermission('FACTURAS_EXPORTAR') ? 
								// Solo deshabilitar si explícitamente cantidadTickets es 0
								(data.cantidadTickets === 0) ? `
							<button class="btn btn-sm btn-icon btn-dt-grid text-muted" title="`+component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_actions.title_sin_tickets', defaultMessage: 'Sin tickets asociados' })+`" data-toggle="tooltip" data-placement="top" disabled>
								<i class="fa fa-download fa-xs"></i>
							</button>` : `
							<button class="action export btn btn-sm btn-icon btn-dt-grid text-success" title="`+component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.column_actions.title_exportar_tickets_a_Excel', defaultMessage: 'Exportar tickets a Excel' })+`" data-toggle="tooltip" data-placement="top">
								<i class="fa fa-download fa-xs"></i>
							</button>`
							: '');
							return html;
						},
						createdCell: function(td, cellData, rowData, row, col) {
							$(td).find('button').tooltip();
						},
						filterType: 'none'
					}],
					drawCallback: function(settings) {
						// Contadores de la franja verde: filas visibles en la página actual
						// sobre el total filtrado que informa el backend (serverSide).
						const info = new $.fn.dataTable.Api(settings).page.info();
						component.setState({
							searchPageRows: info.end - info.start,
							searchTotalRows: info.recordsDisplay
						});

						$(this).find('.action').on('click', function() {
							let data = component.table.row($(this).parents('tr')).data();

							if ($(this).hasClass('view')) {
								component.setState({
									redirectTo: component.props.match.url + '/' + data.id
								});
							}

							// VEC-4067: badge "Tickets N" => modal con los tickets de la factura.
							if ($(this).hasClass('ver-tickets')) {
								component.setState({ ticketsModalFactura: data });
							}

							if ($(this).hasClass('edit')) {
								component.setState({
									redirectTo: component.props.match.url + '/' + data.id + '/edit'
								});
							}

							if ($(this).hasClass('delete')) {
								swal({
									title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_delete.confirm_eliminacion', defaultMessage: '¿Confirma la eliminación?' }),
									text: null,
									icon: "warning",
									buttons: {
										confirm: {
											text: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_delete.confirm_eliminacion.si', defaultMessage: 'Si' }),
											value: true,
											visible: true,
											className: "btn btn-primary",
											closeModal: false
										},
										cancel: {
											text: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_delete.confirm_eliminacion.No', defaultMessage: 'No' }),
											value: null,
											visible: true,
											className: "btn btn-danger",
											closeModal: true,
										}
									}
								})
								.then((isConfirm) => {
									if (isConfirm) {
										fetch(Config.get('apiUrlBase') + '/facturas/' + data.id, {
											method: 'DELETE',
											headers: {
												'Accept': 'application/json',
												'Content-Type': 'application/json',
												'Authorization-Token': localStorage.getItem("token")
											}
										})
										.then(function(response) {
											component.table.ajax.reload(null, false);
											swal(component.props.intl.formatMessage({ id: 'facturasGrid.modal_delete.information_eliminado', defaultMessage: 'Eliminado!' }), "", "success");
										})
										.catch(function(error) {
											swal(component.props.intl.formatMessage({ id: 'facturasGrid.modal_delete.information_error', defaultMessage: 'Error' }), "", "error");
										});
									}
								});
							}
             
						
							if ($(this).hasClass('approve')) {
								let div = document.createElement("div");
								if (sap) {
									var numeroWE = document.createElement('input');
									numeroWE.type = "number";
									numeroWE.className = "swal-content__input";
									numeroWE.placeholder = component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.approve_invoice.placeholder_we', defaultMessage: 'WE *' });
									numeroWE.id = "confirm-WECambioEstado";
									numeroWE.pattern = "[0-9]{10}";

									var errorWE = document.createElement("div");
									errorWE.className = "help-block text-danger field-message error-we";
									errorWE.innerText = component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.approve_invoice.errors_numero_dies_digitos', defaultMessage: 'Debe ser un número de 10 dígitos' });
									errorWE.hidden = true;
									numeroWE.oninput = function(){
										if(this.value.length === 10){
											$(".error-we").attr('hidden',true);					
										}
									};
									var numeroOE = document.createElement('input');
									numeroOE.type = "text";
									numeroOE.className = "swal-content__input swal-input-two";
									numeroOE.placeholder = component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.approve_invoice.placeholder_OE', defaultMessage: 'OE' });
									numeroOE.id = "confirm-OECambioEstado";
									div.append(numeroWE);
									div.append(errorWE);
									div.append(numeroOE);
							  }
								var observaciones = document.createElement('textarea');
								observaciones.placeholder= component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.approve_invoice.placeholder_observaciones', defaultMessage: 'Observaciones' });
								observaciones.className = "swal-content__textarea swal-input-two";
								observaciones.id = "confirm-observacionesCambioEstado";
								
								div.append(observaciones);
							
								function recursiveCall(index) {
								return new Promise((resolve)=>{
									swal({
									title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_approve_invoice.confirm_titel_aprobar', defaultMessage: 'Aprobar' }),
									text: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_approve_invoice.confirm_aprobar_factura', defaultMessage: '¿Confirma que desea aprobar la factura?' }),
									icon: "info",
									content: div,
									buttons: {
										confirm: {
											text: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_approve_invoice.confirm_aprobar_factura.si', defaultMessage: 'Si' }),
											value: true,
											visible: true,
											className: "btn btn-primary",
											closeModal: false,
											id: 'btn-approve'
										},
										cancel: {
											text: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_approve_invoice.confirm_aprobar_factura.no', defaultMessage: 'No' }),
											value: null,
											visible: true,
											className: "btn btn-danger",
											closeModal: true,
										}
									}
								}).then((isConfirm) => {
									if (isConfirm) {
										if(sap) {
											if(numeroWE.value.length === 10){
											} else{
												$(".error-we").prop('hidden',false);
												return resolve(recursiveCall(++index))								
										}
									} 
									component.ajaxHandler.fetch('/facturas/' + data.id + '/aprobar', {
										method: 'POST',
										body: JSON.stringify({
											observaciones: $('#confirm-observacionesCambioEstado').val(),
											oe: $("#confirm-OECambioEstado").val(),
											we: $("#confirm-WECambioEstado").val()
										}),
										headers: {
											'Accept': 'application/json',
											'Content-Type': 'application/json',
											'Authorization-Token': localStorage.getItem("token")
										}
									}).then((response) => {
										if(response.status === 200) {
											component.table.ajax.reload(null, false);
											resolve();
											swal(component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_approve_invoice.information_factura_aprobada', defaultMessage: 'Factura aprobada.' }), "", "success");
										}
									}).catch((error) => {
										component.ajaxHandler.handleError(error);
									});
									}
								});
							});
							}
								
							recursiveCall(0);
							}

							if ($(this).hasClass('reject')) {
								swal({
									title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_refuse_invoice.title_rechazar', defaultMessage: 'Rechazar' }),
									text: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_refuse_invoice.confirm_rechazar_factura', defaultMessage: '¿Confirma que desea rechazar la factura?' }),
									icon: "warning",
									content: {
										element: "textarea",
										attributes: {
											placeholder: "Observaciones",
											id: 'confirm-observacionesCambioEstado'
										}
									},
									buttons: {
										confirm: {
											text: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_refuse_invoice.confirm_rechazar_factura.si', defaultMessage: 'Si' }),
											value: true,
											visible: true,
											className: "btn btn-primary",
											closeModal: false
										},
										cancel: {
											text: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_refuse_invoice.confirm_rechazar_factura.no', defaultMessage: 'No' }),
											value: null,
											visible: true,
											className: "btn btn-danger",
											closeModal: true,
										}
									}
								}).then((isConfirm) => {
									if (isConfirm) {
										component.ajaxHandler.fetch('/facturas/' + data.id + '/rechazar', {
											method: 'POST',
											body: JSON.stringify({
												observaciones: $('#confirm-observacionesCambioEstado').val()
											}),
											headers: {
												'Accept': 'application/json',
												'Content-Type': 'application/json',
												'Authorization-Token': localStorage.getItem("token")
											}
										}).then((response) => {
											if(response.status === 200) {
												component.table.ajax.reload(null, false);
												swal(component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_refuse_invoice.information_factura_rechazada.', defaultMessage: 'Factura rechazada.' }), "", "success");
											}
										}).catch((error) => {
											component.ajaxHandler.handleError(error);
										});
									}
								});
							}

							if ($(this).hasClass('export')) {
								component.setState({ modalExport: true, exportFacturaId: data.id });
							}

							if ($(this).hasClass('declarePayment')) {
								let modalContent = document.createElement('div');
								let fileInput = document.createElement('input');
								fileInput.type = 'file';
								fileInput.id = 'confirm-archivosPago';
								fileInput.multiple = false;
								fileInput.accept = '.pdf,.jpg,.jpeg,.png';
								fileInput.className = 'swal-content__input mb-2';
								modalContent.appendChild(fileInput);

								let observaciones = document.createElement('textarea');
								observaciones.placeholder = "Observaciones";
								observaciones.id = 'confirm-observacionesCambioEstado';
								observaciones.className = 'swal-content__textarea';
								modalContent.appendChild(observaciones);

								swal({
									title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_declare_payment.title_declarar_pago', defaultMessage: 'Declarar Pago' }),
									text: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_declare_payment.confirm_declarar_pago', defaultMessage: '¿Confirma el pago de la factura?' }),
									icon: "warning",
									content: modalContent,
									buttons: {
										confirm: {
											text: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_declare_payment.confirm_declarar_pago.si', defaultMessage: 'Si' }),
											value: true,
											visible: true,
											className: "btn btn-primary",
											closeModal: false
										},
										cancel: {
											text: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_declare_payment.confirm_declarar_pago.no', defaultMessage: 'No' }),
											value: null,
											visible: true,
											className: "btn btn-danger",
											closeModal: true,
										}
									}
								}).then((isConfirm) => {
									if (isConfirm) {
										let files = document.getElementById('confirm-archivosPago').files;
										let formData = new FormData();
										formData.append('observaciones', $('#confirm-observacionesCambioEstado').val());
										for (let i = 0; i < files.length; i++) {
											formData.append('archivos', files[i]);
										}

										component.ajaxHandler.fetchMultipart('/facturas/' + data.id + '/pagar', {
											method: 'POST',
											body: formData,
											headers: {
												'Authorization-Token': localStorage.getItem("token")
											}
										})
											.then((response) => {
												if (response.status === 200) {
													component.table.ajax.reload(null, false);
													swal(component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_declare_payment.information_declaracion_pago_exitoso.', defaultMessage: 'Pago Declarado con Éxito.' }), "", "success");
												}
											})
											.catch((error) => {
												component.ajaxHandler.handleError(error);
											});
									}
								});
							}

							if ($(this).hasClass('downloadReceipt')) {
								if (data.comprobantePago) {
									component.ajaxHandler.fetchMultipart('/facturas/adjunto/' + encodeURIComponent(data.comprobantePago), {
										method: 'GET',
										headers: {
											'Authorization-Token': localStorage.getItem("token")
										}
									})
										.then(response => {
											if (response.status === 200) {
												return response.blob();
											} else {
												throw new Error('No se pudo descargar el comprobante');
											}
										})
										.then(fileBlob => {
											let fileUrl = URL.createObjectURL(fileBlob);
											$("<a />", {
												href: fileUrl,
												download: data.comprobantePago
											}).appendTo("body").get(0).click();
										})
										.catch(() => {
											swal(component.props.intl.formatMessage({ id: 'facturasGrid.downloadReceipt.error', defaultMessage: 'No se pudo descargar el comprobante.' }), "", "error");
										});
								} else {
									swal(component.props.intl.formatMessage({ id: 'facturasGrid.downloadReceipt.no_file', defaultMessage: 'No hay comprobante disponible.' }), "", "info");
								}
							}

							if ($(this).hasClass('close-factura')) {
								const confirmMsgEl = document.createElement('p');
								confirmMsgEl.style.textAlign = 'center';
								confirmMsgEl.textContent = component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_close_invoice.confirm_cerrar_factura', defaultMessage: '¿Confirma que desea cerrar la factura? Esta acción es irreversible.' });
								swal({
									title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_close_invoice.title_cerrar', defaultMessage: 'Cerrar factura' }),
									content: confirmMsgEl,
									icon: "warning",
									buttons: {
										confirm: {
											text: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_close_invoice.confirm_cerrar_factura.si', defaultMessage: 'Si' }),
											value: true,
											visible: true,
											className: "btn btn-primary",
											closeModal: false
										},
										cancel: {
											text: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_close_invoice.confirm_cerrar_factura.no', defaultMessage: 'No' }),
											value: null,
											visible: true,
											className: "btn btn-danger",
											closeModal: true,
										}
									}
								}).then((isConfirm) => {
									if (isConfirm) {
										component.ajaxHandler.fetch('/facturas/' + data.id + '/cerrar', {
											method: 'POST',
											headers: {
												'Accept': 'application/json',
												'Content-Type': 'application/json',
												'Authorization-Token': localStorage.getItem("token")
											}
										}).then((response) => {
											if (response.status === 200) {
												component.table.ajax.reload(null, false);
												swal(component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_close_invoice.information_factura_cerrada', defaultMessage: 'Factura cerrada.' }), "", "success");
											} else {
												return response.json().then((json) => {
													const msgEl = document.createElement('p');
													const rawMessage = typeof json.mensaje === 'string' ? json.mensaje : '';
													const plainMessage = rawMessage.trim();
													const translatedMessage = backendStrings[rawMessage]
														? component.props.intl.formatMessage(backendStrings[rawMessage], json.context || {})
														: null;
													msgEl.style.textAlign = 'center';
													msgEl.textContent = translatedMessage
														|| plainMessage
														|| component.props.intl.formatMessage(backendStrings['errors.default']);
													swal({
														title: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.modal_close_invoice.error_title', defaultMessage: 'Error' }),
														content: msgEl,
														icon: 'error',
														button: { className: 'btn btn-primary' }
													});
												});
											}
										}).catch((error) => {
											component.ajaxHandler.handleError(error);
										});
									}
								});
							}
						});
					}
				}, datatablesConfig(this.props.intl))
			);

			// Aplicar filtros persistidos si existen; si no, aplicar el default
			// (rango de fecha de creación = último mes). Este es el PRIMER y ÚNICO
			// pedido al backend, porque la tabla se creó con deferLoading.
			// Siempre vía handleFilterChange para
			// limpiar lo que DataTables pudo restaurar desde su propio stateSave.
			// La persistencia es incondicional: ya no hay switch "Persistir Filtros",
			// así que basta con que exista la entrada (el `activo` de las entradas
			// viejas se descarta).
			try {
				var savedFilters = localStorage.getItem(Security.claveDeUsuario(FACTURAS_FILTROS_STORAGE_KEY));
				var parsedFilters = savedFilters ? JSON.parse(savedFilters) : null;
				if (parsedFilters) {
					var filtersToApply = Object.assign({}, parsedFilters);
					delete filtersToApply.activo;
					var normalized = component.normalizeFilterQuery(filtersToApply);
					component.setState({ filterQuery: normalized });
					component.handleFilterChange(normalized);
				} else {
					var defaultQuery = component.normalizeFilterQuery(component.getDefaultFilterQuery());
					component.setState({ filterQuery: defaultQuery });
					component.handleFilterChange(defaultQuery);
				}
			} catch (e) {
				var fallbackQuery = component.normalizeFilterQuery(component.getDefaultFilterQuery());
				component.setState({ filterQuery: fallbackQuery });
				component.handleFilterChange(fallbackQuery);
			}

		new $.fn.dataTable.Buttons(this.table, {
			buttons: [
				{
					name: 'filterReset',
					text: '<img id="filterReset" class="filter-reset" src="'+LimpiarFiltros+'"></i>',
					// Key RENOMBRADA a propósito: el botón ahora también restaura las columnas
					// visibles, y el catálogo i18n remoto tiene el texto viejo atado a la key
					// anterior (cambiar solo el defaultMessage no se vería).
					titleAttr: component.props.intl.formatMessage({ id: 'facturasGrid.initGrid.tools_clean_filters.title_restaurar_vista', defaultMessage: 'Restaurar filtros, columnas y ordenamiento' }),
					action: function (e, dt, node, config) {
						// Mismo reset que la "x" de la franja de resultados.
						component.handleFilterReset();
					}
			}, {
				// Selector de columnas: botón estándar de DataTables Buttons (mismo que
				// usan Infracciones y otras 35 grillas). Solo cambia qué columnas se ven;
				// los filtros del panel siguen aplicados aunque su columna se oculte,
				// porque el panel es la única fuente de verdad de los filtros.
				// La visibilidad persiste sola vía el stateSave de la grilla
				// (localStorage `DataTables_FacturasGrid`, acotada al usuario en VEC-4018).
				extend: 'colvis',
				name: 'columns',
				// Excluye columnas sin título (th vacío) y las marcadas explícitamente como no-colvis.
				columns: ':not(.no-colvis):not(:empty)',
				text: '<i class="la la-columns"></i>',
				titleAttr: component.props.intl.formatMessage({ id: 'facturasGrid.tools_select_columns.title_select_columns', defaultMessage: 'Seleccionar columnas' })
			},
			Security.hasPermission('FACTURAS_DETALLE_EXPORTAR')
			&& createExcelExportButton(
					component,
					'/facturas/exportar-excel-detalle',
					'facturas-detalle.xlsx',
					component.props.intl,
					true // Incluir parámetros de filtros, búsqueda y ordenamiento de la tabla
			)
		].filter(Boolean) // Filtra los botones que no tienen permiso (elimina los valores false, null, undefined, '' y 0)
			
		});

			this.table.buttons(0, null).container().appendTo('#buttons');

			this.table.button('filterReset:name')
				.nodes()
				.attr('data-toggle', 'tooltip')
				.attr('data-position', 'top');
			$('[data-toggle="tooltip"]').tooltip();
		}).catch(function(error) {
			component.ajaxHandler.handleError(error);
		}).finally(() => {
			this.setState({
				loading: false
			});
		});
	}
}

export default injectIntl(FacturasGrid);
